import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor( private auth:AuthService ) {

  }

  canActivate(){

    if( this.auth.isAuthenticated() ){
      console.log('autenticado');
      return true
    }else{
      console.error('bloqueado');
      setTimeout(()=>{ this.auth.login() }, 6000)
      return false
    }
  }

}
